import { render, staticRenderFns } from "./LanguageMaster.vue?vue&type=template&id=ea60b986"
import script from "./LanguageMaster.vue?vue&type=script&lang=js"
export * from "./LanguageMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports